import type { SlideProps } from '@mui/material'
import { Slide, Snackbar as MuiSnackbar, Box } from '@mui/material'
import { hideToast, useToast } from './showToast'
import { ToastAlert } from '../toast-alert'
import { CheckMark, WarningCircle } from '../../../localComponents/svg-icons'
import { theme } from '../../theme'

function TransitionRight(props: SlideProps) {
  return <Slide {...props} direction='left' />
}

export const Toast = () => {
  const { open, options } = useToast()

  const {
    key,
    message,
    title,
    type = 'info',
    autoHideDuration = 4000,
    disableCloseOnClickAway = false,
  } = options || {}

  let backgroundColor
  let IconComponent: React.ReactNode = null

  if (type === 'error') {
    backgroundColor = 'criticalBg4'
    IconComponent = (
      <Box
        sx={{
          backgroundColor: 'criticalBg',
          padding: '4px',
          borderRadius: 'var(--cornerRadius__SCF_cornerRadiusS)',
          height: '100%',
        }}
      >
        <WarningCircle />
      </Box>
    )
  } else if (type === 'success') {
    backgroundColor = 'approveBg4'
    IconComponent = (
      <Box
        sx={{
          backgroundColor: 'approveBg',
          padding: '4px',
          borderRadius: 'var(--cornerRadius__SCF_cornerRadiusS)',
          height: '100%',
        }}
      >
        <CheckMark />
      </Box>
    )
  }

  return (
    <MuiSnackbar
      key={key}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      autoHideDuration={autoHideDuration}
      message={message}
      open={open}
      sx={{
        top: 32,
        '& .MuiSvgIcon-root': {
          width: '20px',
          height: '20px',
        },
      }}
      TransitionComponent={TransitionRight}
      onClose={(_, reason) => {
        if (disableCloseOnClickAway && reason === 'clickaway') {
          return
        }
        hideToast()
      }}
    >
      <span>
        <ToastAlert
          onClose={hideToast}
          severity={type}
          variant='filled'
          sx={{
            width: '100%',
            '&.MuiAlert-root': {
              backgroundColor,
              border: '1px solid',
              borderColor: 'stroke2',
              boxShadow: theme.elevations.flyout,
              paddingX: 'var(--spacing__SCF_spacingS)',
              paddingY: 'var(--spacing__SCF_spacingXS)',
            },
            '& .MuiAlert-action .MuiIconButton-root': {
              borderRadius: 'var(--cornerRadius__SCF_cornerRadiusS)',
            },
          }}
          title={title}
          description={message}
          titleProps={{
            overflow: 'hidden',
          }}
          icon={IconComponent}
        />
      </span>
    </MuiSnackbar>
  )
}
